import { Loading } from 'element-ui';

const loadingControl = {
  clickStop: false, // 控制是否支持单击关闭遮罩层
  loadingEl: null,
  requestCount: 0,
  delayTime: 300,
  closeTime: 0, // 控制最长遮罩时长，0时不控制，单位毫秒
  loadingTime: 0,
  step: 1000, // 遮罩时长步进间隔，毫秒
  timer: null,
  whiteList: [], // 白名单
  routeWhiteList: [], // 路由白名单

  show(url) {
    if(window.Vue.$router){
      if (this.routeWhiteList.includes(window.Vue.$router.currentRoute.path)) {
        this.stop();
        return;
      }
      if (url && this.whiteList.includes(url)) {
        return;
      }
      this.requestCount++;
      if (this.requestCount === 1 && !this.isLoading()) {
        this.loadingTime = 0;
        this.loadingEl = Loading.service({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        });
        if (this.clickStop) {
          this.loadingEl.$el.addEventListener('click', this.stop.bind(this));
        }
        if (this.closeTime) {
          this.timer = setInterval(() => {
            if (this.loadingTime >= this.closeTime) {
              this.timer = clearInterval(this.timer);
              this.stop();
              return;
            }
            this.loadingTime += this.step;
          }, this.step);
        }
      }
    }
    
  },
  hide(url) {
    if (this.routeWhiteList.includes(window.location.hash)) {
      this.stop();
      return;
    }
    if (url && this.whiteList.includes(url)) {
      return;
    }
    setTimeout(() => {
      this.requestCount = Math.max(0, this.requestCount - 1);
      if (this.requestCount === 0 && this.isLoading()) {
        if (this.clickStop) {
          this.loadingEl.$el.removeEventListener('click', this.stop.bind(this));
        }
        this.loadingEl.close();
        this.loadingEl = null;
      }
    }, this.delayTime);
  },

  stop() {
    this.requestCount = 0;
    if (this.requestCount === 0 && this.isLoading()) {
      if (this.clickStop) {
        this.loadingEl.$el.removeEventListener('click', this.stop.bind(this));
      }
      this.loadingEl.close();
      this.loadingEl = null;
    }
  },

  isLoading() {
    return Boolean(this.loadingEl);
  }
};

export default loadingControl;
